<template>
    <div class="report">
        <div class="header">
            <div class="store-box" @click="showPopup = true">
                <div>{{ checkedStore.name }}</div>
                <div class="store-icon">
                    <van-icon name="play" />
                </div>
            </div>
            <div class="btn-add" @click="onAdd">
                <van-icon name="plus" />
                <span>新建</span>
            </div>
        </div>

        <div class="report-list-com">
            <ReportList v-if="storeNo" ref="reportRef" :storeNo="storeNo" :storeName="checkedStore.name" :hideSearch="true" />
        </div>

        <van-popup v-model="showPopup" round position="bottom" closeable class="popup">
            <picker title="更换门店" v-model="checkedStore" :list="storeList" @change="onChange"></picker>
        </van-popup>
    </div>
</template>

<script>
    import ReportList from './list.vue'
    import request from "@/utils/request";
    import Picker from '@/components/Picker';

    export default {
        name: 'Report',
        components: { ReportList, Picker },
        data() {
            return {
                showPopup: false,
                checkedStore: { id: -1, name: '' },
                storeList: [],
                storeNo: '',
            }
        },
        created() {
            this.getEmployeeEnableStore()
            this.getEmployeeAllStore()
        },
        methods: {
            // 获取当前人门店
            getEmployeeEnableStore() {
                request({
                    url: '/employeeStore/getEmployeeEnableStore',
                    method: "get",
                }).then(({ data }) => {
                    this.checkedStore.name = data.storeName
                    this.checkedStore.id = data.id
                    this.storeNo = data.storeNo
                })
            },
            // 获取主任门店列表
            getEmployeeAllStore() {
                request({
                    url: '/employeeStore/getEmployeeAllStore',
                    method: "get",
                }).then(({ data }) => {
                    this.storeList = data
                })
            },
            onChange(data) {
                this.checkedStore = data
                this.storeNo = data.storeNo
                this.showPopup = false

                this.$nextTick(() => {
                    this.$refs.reportRef.init()
                })
            },
            onAdd() {
                if (!this.storeNo || !this.checkedStore.name) {
                    this.$toast('请选择报备门店')
                    return
                 }
                this.$router.push(`/CRM/reportAdd?type=add&storeNo=${this.storeNo}&storeName=${this.checkedStore.name}`)
            },
        }
    }
</script>

<style lang='less' scoped>
    .report {
        height: 100%;
        font-size: 30px;
        color: #35434c;
        background-color: #fff;
        overflow-y: scroll;
    }

    .header {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 102px;
        padding: 0 30px;
        box-shadow: 0px 2px 10px 2px rgba(0, 0, 0, 0.1);
        z-index: 9;

        .btn-add {
            display: flex;
            align-items: center;
            font-size: 24px;
            height: 50px;
            padding: 0 20px;
            background-color: #2FD0D5;
            color: #fff;
            border-radius: 50px;

            >span {
                margin-left: 6px;
            }
        }

        .store-box {
            display: flex;
            align-items: center;
        }

        .store-icon {
            margin-left: 4px;
            transform: rotateZ(90deg);
        }
    }

    .report-list-com {
        height: calc(100% - 102px)
    }
</style>
